import { OverlayContainer } from '@angular/cdk/overlay';
import { Component, HostBinding, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthGuard } from 'src/app/authGuardClass';
import { ComponentsService } from 'src/app/components.service';
import { EventService } from 'src/app/services/event.service';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { DateAdapter } from '@angular/material/core';
import { ClientInfoDTO } from './models/client-info-dto.model';

@Component({
    selector: 'app-holder',
    templateUrl: './holder.component.html',
    styleUrls: ['./holder.component.scss'],
    providers: [DatePipe]
})
export class HolderComponent implements OnInit {
    opened = true;
    env;
    toggleControl = new FormControl(false);
    @HostBinding('class') className = '';
    clients: any[] = [];
    loadedPerms: boolean = false;
    username: string;
    perms;
    activeClient;
    isSuperAdmin;
    betControlPage: boolean = false;
    startAllClicked = false;
    stopAllClicked = false;
    showTranslations = false;
    tableShow: any;
    gameCode: string;
    userName: string;
    client_with_oldest_opened_ticket: string = '';
    game_with_oldest_opened_ticket: string = '';
    dropdownOptions: string[] = ['ALL'];
    selectedOption: string = 'ALL';
    selectedClients: string[] = [];
    date = new Date();
    defaultDateFrom: Date = new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        1
    );
    defaultDateTo: Date = new Date();
    dateFrom: any;
    dateTo: any;
    selectedStatus: string = '';
    selectedUser: string = '';

    clientInfo: ClientInfoDTO[] = [];

    betStatus: number;
    showStartButton: boolean = false;
    showStopButton: boolean = false;

    confirmationVisible = false;
    confirmationMessage = '';
    confirmationAction: 'start' | 'stop' | null = null;

    sortKey: string = '';
    sortDirection: string = 'asc';
    isLoading: boolean = true;

    constructor(
        public router: Router,
        public service: ComponentsService,
        private overlay: OverlayContainer,
        private authGuard: AuthGuard,
        private eventService: EventService,
        private http: HttpClient,
        private datePipe: DatePipe,
        private dateAdapter: DateAdapter<Date>
    ) {
        this.dateAdapter.setLocale('en-GB');
    }

    addGamesInDropdownList() {
        this.service.getAllGames().subscribe((data) => {
            let allGames: any = data.data;
            allGames.forEach((item) => {
                this.dropdownOptions.push(item.gameCode);
            });
        });
    }

    ngOnInit(): void {
        const defaultDayFrom = this.defaultDateFrom.getDate();
        const defaultMonthFrom = this.defaultDateFrom.getMonth() + 1;
        const defaultYearFrom = this.defaultDateFrom.getFullYear();
        this.dateFrom = `${defaultYearFrom}-${defaultMonthFrom}-${defaultDayFrom}`;

        const defaultDayTo = this.defaultDateTo.getDate();
        const defaultMonthTo = this.defaultDateTo.getMonth() + 1;
        const defaultYearTo = this.defaultDateTo.getFullYear();
        this.dateTo = `${defaultYearTo}-${defaultMonthTo}-${defaultDayTo}`;

        // this.getAllBettingStatusMethod();
        this.addGamesInDropdownList();
        this.env = environment.path;
        this.perms = this.service.getUsersPerm();
        this.loadedPerms = true;
        this.userName = this.perms.username;

        this.isSuperAdmin = this.service.getUsersPerm().superAdmin == 1;
        if (this.isSuperAdmin == 1) {
            this.betControlPage = true;
        } else {
            this.betControlPage = false;
        }

        this.service.setClientUuid(this.perms.clientUuid);
        this.service
            .clientName(this.service.getClientUuid())
            .subscribe((data) => {
                this.activeClient = data.clientName;
            });

        // Only get client names if the user is a superadmin
        if (this.perms && this.perms.superAdmin == 1) {
            // Fetch client list for dropdown/display purposes
            this.service.getClientNames().subscribe({
                next: (clients) => {
                    console.log('Received clients data:', clients);
                    if (
                        clients &&
                        clients.data &&
                        Array.isArray(clients.data)
                    ) {
                        this.clients = clients.data;
                        console.log('Processed clients:', this.clients);
                        this.getClientInfo();
                    } else {
                        console.warn('Invalid clients data received:', clients);
                        this.clients = [];
                        this.clientInfo = [];
                    }
                },
                error: (error) => {
                    console.error('Error fetching client names:', error);
                    this.clients = [];
                    this.clientInfo = [];
                }
            });

            const formattedDateString = this.datePipe.transform(
                new Date(),
                'dd/MM/yyyy'
            );
        }

        this.service.openSideBar.subscribe((data) => {
            if (data) {
                this.opened = false;
            } else {
                this.opened = true;
            }
        });

        this.toggleControl.valueChanges.subscribe((darkMode) => {
            const darkClassName = 'darkMode';
            this.className = darkMode ? darkClassName : '';
            this.eventService.publishEvent({
                type: 'event-theme-change',
                payload: darkMode
            });
            if (darkMode) {
                this.overlay.getContainerElement().classList.add(darkClassName);
            } else {
                this.overlay
                    .getContainerElement()
                    .classList.remove(darkClassName);
            }
        });
    }

    navigateToTranslations(): void {
        this.betControlPage = false;
        this.router.navigate(['home/translations']);
    }

    activateTranslations() {
        this.betControlPage = false;
        this.showTranslations = true;
    }

    formatDate(date: string): string {
        if (date == null) {
            return null;
        }
        const kotDate = new Date(date);

        const day = kotDate.getDate().toString().padStart(2, '0');
        const month = (kotDate.getMonth() + 1).toString().padStart(2, '0');
        const year = kotDate.getFullYear();

        const hours = kotDate.getHours().toString().padStart(2, '0');
        const minutes = kotDate.getMinutes().toString().padStart(2, '0');
        const seconds = kotDate.getSeconds().toString().padStart(2, '0');

        return `${day}/${month}/${year} - ${hours}:${minutes}:${seconds}`;
    }

    logOut() {
        this.authGuard.logOut();
    }

    clientChange(client) {
        console.log(
            `[HolderComponent] Client selected from holder dropdown: ${client.clientUuid}, name: ${client.name}`
        );
        this.activeClient = client.name;
        this.service.changeClient(client.clientUuid);
        this.service.clientChanged.emit(client);

        // Update the activeClient with the proper client name
        this.service
            .clientName(this.service.getSelectedClientUuid())
            .subscribe((data) => {
                this.activeClient = data.clientName;
            });
    }

    toggleSuperAdmin_home() {
        // This method should not modify service state - client changes should only be initiated from header
        console.log(
            '[HolderComponent] toggleSuperAdmin_home called, but holder should not modify service state'
        );
        this.betControlPage = false;
        this.showTranslations = false;
    }

    toggleSuperAdminPerm_BetControl() {
        const defaultDayFrom = this.defaultDateFrom.getDate();
        const defaultMonthFrom = this.defaultDateFrom.getMonth() + 1;
        const defaultYearFrom = this.defaultDateFrom.getFullYear();
        this.dateFrom = `${defaultYearFrom}-${defaultMonthFrom}-${defaultDayFrom}`;
        this.defaultDateFrom = new Date(
            new Date().getFullYear(),
            new Date().getMonth(),
            1
        );

        const defaultDayTo = this.defaultDateTo.getDate();
        const defaultMonthTo = this.defaultDateTo.getMonth() + 1;
        const defaultYearTo = this.defaultDateTo.getFullYear();
        this.dateTo = `${defaultYearTo}-${defaultMonthTo}-${defaultDayTo}`;
        this.defaultDateTo = new Date();

        this.betControlPage = true;
        this.showTranslations = false;
        this.refreshData();
    }

    get totalPayin(): number {
        return this.clientInfo.reduce(
            (sum, client) => sum + Number(client.payin || 0),
            0
        );
    }

    get totalPayout(): number {
        return this.clientInfo.reduce(
            (sum, client) => sum + Number(client.payout || 0),
            0
        );
    }

    get totalRevenue(): number {
        return this.clientInfo.reduce(
            (sum, client) => sum + Number(client.revenue || 0),
            0
        );
    }

    get totalTickets(): number {
        return this.clientInfo.reduce(
            (sum, client) => sum + Number(client.ticketsNumber || 0),
            0
        );
    }

    getClientInfo() {
        this.isLoading = true;
        const filterData: any = {
            ...(this.dateFrom && { dateFrom: this.dateFrom }),
            ...(this.dateTo && { dateTo: this.dateTo + ' 23:59:59' })
        };

        const clientsToUse =
            this.selectedClients?.length > 0
                ? this.selectedClients
                : this.clients;

        console.log('Getting client info with:', {
            clients: this.clients,
            filterData
        });

        if (!clientsToUse || clientsToUse.length === 0) {
            console.warn('No clients available for fetching info');
            this.clientInfo = [];
            return;
        }

        this.service.getAllClientInfo(clientsToUse, filterData).subscribe({
            next: (data) => {
                console.log('Received client info data:', data);
                this.clientInfo = this.formatClientInfo(data);
                console.log('Formatted client info:', this.clientInfo);
            },
            error: (error) => {
                console.error('Error fetching client info:', error);
                this.clientInfo = [];
            },
            complete: () => {
                this.isLoading = false;
            }
        });
    }

    formatClientInfo(data: any): ClientInfoDTO[] {
        if (!Array.isArray(data)) {
            console.warn(
                'Expected array of client data, received:',
                typeof data,
                data
            );
            return [];
        }

        return data
            .filter((item) => item && !item.error) // Filter out error responses
            .map((item) => {
                const clientInfoDto: ClientInfoDTO = {
                    clientName: item.clientName || 'Unknown Client',
                    payin: item.totalPayin?.toString() || '0',
                    payout: item.totalPayout?.toString() || '0',
                    ticketsNumber: item.ticketsNumber || 0,
                    profit: item.profit?.toString() || '0',
                    revenue: item.revenue?.toString() || '0'
                };

                return clientInfoDto;
            });
    }

    startAll() {
        this.confirmationMessage = 'START betting service?';
        this.confirmationAction = 'start';
        this.confirmationVisible = true;
    }

    stopAll() {
        this.confirmationMessage = 'STOP betting service?';
        this.confirmationAction = 'stop';
        this.confirmationVisible = true;
    }

    onConfirmAction() {
        const status = this.confirmationAction === 'start' ? 1 : 0;

        if (this.selectedOption === 'ALL') {
            this.service
                .setAllBettingStatus(status, this.userName)
                .subscribe(() => this.refreshData());
        } else {
            this.service
                .setGameBettingStatus(status, this.selectedOption)
                .subscribe(() => this.refreshData());
        }

        this.confirmationAction = null;
    }

    clearFilters() {
        this.defaultDateFrom = new Date(
            new Date().getFullYear(),
            new Date().getMonth(),
            1
        );
        this.defaultDateTo = new Date();
        this.selectedClients = [];

        const defaultDayFrom = this.defaultDateFrom.getDate();
        const defaultMonthFrom = this.defaultDateFrom.getMonth() + 1;
        const defaultYearFrom = this.defaultDateFrom.getFullYear();
        this.dateFrom = `${defaultYearFrom}-${defaultMonthFrom}-${defaultDayFrom}`;

        const defaultDayTo = this.defaultDateTo.getDate();
        const defaultMonthTo = this.defaultDateTo.getMonth() + 1;
        const defaultYearTo = this.defaultDateTo.getFullYear();
        this.dateTo = `${defaultYearTo}-${defaultMonthTo}-${defaultDayTo}`;

        this.getClientInfo();
    }

    refreshData() {
        // this.getAllBettingStatusMethod();

        const formattedDateString = this.datePipe.transform(
            new Date(),
            'dd/MM/yyyy'
        );
        this.defaultDateFrom = new Date(
            new Date().getFullYear(),
            new Date().getMonth(),
            1
        );
        this.defaultDateTo = new Date();
        this.selectedClients = [];
        this.getClientInfo();
    }
    toggleRowSelection(show: any): void {
        show.selected = !show.selected;
    }

    sortBy(key: string) {
        if (this.sortKey === key) {
            this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
        } else {
            this.sortKey = key;
            this.sortDirection = 'asc';
        }

        // Sortirajte tableData niz na osnovu sortKey i sortDirection
        this.clientInfo.sort((a, b) => {
            const aValue = a[this.sortKey];
            const bValue = b[this.sortKey];

            if (aValue < bValue) return this.sortDirection === 'asc' ? -1 : 1;
            if (aValue > bValue) return this.sortDirection === 'asc' ? 1 : -1;
            return 0;
        });
    }

    getRevenueForSelectedYearAndMonth(year?: number, month?: number) {
        this.service
            .getRevenueForSelectedYearAndMonth(year, month)
            .subscribe((data) => {
                this.tableShow = data;
                let date = new Date();
                let ticket_id = 0;
                let tempClientId: string = '';
                let tempGameCode: string = '';
                this.tableShow.forEach((type) => {
                    if (type.oldest_opened_date != null) {
                        if (
                            new Date(type.oldest_opened_date) < new Date(date)
                        ) {
                            date = type.oldest_opened_date;
                            ticket_id = type.oldest_opened_ticket;

                            tempClientId = type.clientUuid;
                            tempGameCode = type.gameCode;
                        }
                    }
                    type.bet_allowed = type.bet_allowed == 1 ? 'ON' : 'OFF';
                    type.open_num = Number(type.open_num);
                    type.bet_toggle_timestamp = this.formatDate(
                        type.bet_toggle_timestamp
                    );
                });

                this.client_with_oldest_opened_ticket = tempClientId;
                this.game_with_oldest_opened_ticket = tempGameCode;

                this.tableShow.sort((a, b) => b.open_num - a.open_num);
            });
    }

    setDateFrom(event: any): void {
        const selectedDate = new Date(event.value); // event.value contains the selected full date

        const selectedDay = selectedDate.getDate(); // Get the day of the month
        const selectedMonth = selectedDate.getMonth() + 1; // Get the month (1-based, so add 1)
        const selectedYear = selectedDate.getFullYear(); // Get the year

        // Format the date in YYYY-MM-DD format
        this.dateFrom = `${selectedYear}-${selectedMonth}-${selectedDay}`;
    }

    setDateTo(event: any): void {
        const selectedDate = new Date(event.value); // event.value contains the selected full date

        const selectedDay = selectedDate.getDate(); // Get the day of the month
        const selectedMonth = selectedDate.getMonth() + 1; // Get the month (1-based, so add 1)
        const selectedYear = selectedDate.getFullYear(); // Get the year

        // Format the date in YYYY-MM-DD format
        this.dateTo = `${selectedYear}-${selectedMonth}-${selectedDay}`;
    }

    parseDateString(dateString: string): Date {
        const [day, month, year] = dateString.split('/');
        return new Date(+year, +month - 1, +day);
    }
}
